import { Injectable } from '@angular/core';
import { Functions, httpsCallable, HttpsCallableResult } from '@angular/fire/functions';
import { AlertService } from '../ui/alert';
import { LoaderService } from '../ui/loader';
import { FunctionResponse } from '../../shared/models/response';

interface PartnerImportResultItem {
    email? : string;
    status : 'success' | 'failed';
    uid?   : string;
    error? : string;
}

interface BatchCreatePartnersResponse {
    success: boolean;
    message: string;
    results: PartnerImportResultItem[];
}

@Injectable({
  	providedIn: 'root'
})
export class DataImporterService {
  	constructor(private functions: Functions, private alertService: AlertService, private loaderService: LoaderService) { }

	async importData(collectionName: string, dataArray: any[]): Promise<FunctionResponse<any> | null> {
		this.loaderService.show();

		try {
			const callable = httpsCallable<any, FunctionResponse<any>>(this.functions, 'batchCreateDocuments');
			const result   = await callable({ collectionName, dataArray });

			this.loaderService.hide();

			if(result.data.success) {
				this.alertService.success(result.data.message, 'Éxito en la Importación');

				return result.data;
			} else {
				this.alertService.error(result.data.message || 'Error desconocido durante la importación.', 'Error de Importación');

				return null;
			}
		} catch(error: any) {
			this.loaderService.hide();
			this.alertService.error(error.message || 'Error inesperado al conectar con el servicio de importación.', 'Error de Conexión');

			return null;
		}
	}

	async importPartners(partnersData: any[]): Promise<HttpsCallableResult<BatchCreatePartnersResponse> | null> {
		this.loaderService.show();

		try {
			const callable = httpsCallable<any, BatchCreatePartnersResponse>(this.functions, 'batchCreatePartnersWithAuth');
			const result   = await callable({ partnersData });

			this.loaderService.hide();

			let successCount  = 0;
			let failCount     = 0;
			let errorMessages: string[] = [];

			result.data.results.forEach((r: PartnerImportResultItem) => {
				if(r.status === 'success') {
					successCount++;
				} else {
					failCount++;

					errorMessages.push(`Cliente ${r.email}: ${r.error}`);
				}
			});

			if (result.data.success) {
				this.alertService.success(`${successCount} clientes importados exitosamente.`, 'Éxito en la Importación de Clientes');

				return result;
			} else {
				this.alertService.error(`Se importaron ${successCount} clientes, ${failCount} fallaron. Detalles: \n${errorMessages.join('\n')}`, 'Errores en la Importación de Clientes');

				return null;
			}
		} catch(error: any) {
			this.loaderService.hide();
			this.alertService.error(error.message || 'Error inesperado al conectar con el servicio de importación de clientes.', 'Error de Conexión');

			return null;
		}
	}
}
